import { render, staticRenderFns } from "./LostFoundSection.vue?vue&type=template&id=4bf0a160&scoped=true"
import script from "./LostFoundSection.vue?vue&type=script&lang=js"
export * from "./LostFoundSection.vue?vue&type=script&lang=js"
import style0 from "./LostFoundSection.vue?vue&type=style&index=0&id=4bf0a160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf0a160",
  null
  
)

export default component.exports